import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["childRef", "className"];
import React from 'react';
/**
 * Iframe element isolated for DI purposes
 */
export var IFrame = function IFrame(_ref) {
  var childRef = _ref.childRef,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
  return /*#__PURE__*/React.createElement("iframe", _extends({
    className: className
  }, props, {
    ref: childRef,
    title: props.title
  }));
};